import axios from '../axios';
import config from '../config';

const backend_url = config.backend_url;

export const fetchSellerData = (id) =>
  axios.get(`/api/seller-data/${id}`, { withCredentials: true });

export const clearSession = () =>
  axios.post('/api/clear-session', {}, { withCredentials: true });

export const submitAdditionalInput = (sellerId, additionalInput) =>
  axios.post('/api/submit-additional-input', { seller_id: sellerId, additional_input: additionalInput }, { withCredentials: true });

export const generateAd = (id) =>
  axios.get(`/api/generate-ad/${id}`, { withCredentials: true });

export const deleteSellerData = (id) =>
  axios.delete(`/api/delete-seller-data/${id}`, { withCredentials: true });

// ------------------ NEW / FIXED PARTS ------------------ //

// 1) Update ANY fields (PUT)
export const updateSellerDataAll = (dataId, payload) =>
  axios.put(`/api/update-seller-data/${dataId}`, payload, { withCredentials: true });

// 2) Update only the ad (POST /api/update-ad)
export const updateAd = (payload) =>
  axios.post('/api/update-ad', payload, { withCredentials: true });

// ------------------------------------------------------- //

export default {
  fetchSellerData,
  clearSession,
  submitAdditionalInput,
  generateAd,
  deleteSellerData,
  // We can export them separately or as part of the default
  updateSellerDataAll,
  updateAd,
};
